module.exports = __webpack_public_path__ + "static/Symphonia-end-71bbb49326482f22895e6ed342c4af21.png";